import {hydrateRoot,createRoot} from 'react-dom/client';
import App from './App';
import './style.css';
import {normalizeRoutePath} from './routes';
const root=document.getElementById('root')!;
const app=<App path={normalizeRoutePath(window.location.pathname)}/>;
if(root.children.length) hydrateRoot(root,app); else createRoot(root).render(app);

import './experience.css';
import './v3.css';

// Restore fragment destinations after hydration and local fonts have settled.
const initialHash=window.location.hash;
if(initialHash){void document.fonts.ready.then(()=>requestAnimationFrame(()=>{
 if(window.location.hash!==initialHash||window.scrollY>10)return;
 let id:string;try{id=decodeURIComponent(initialHash.slice(1))}catch{return}
 document.getElementById(id)?.scrollIntoView({behavior:'instant',block:'start'});
}));}

import './v4.css';

import './v5.css';

import './fonts.css';

import './v6.css';

import './v7.css';

import './auth.css';
import './approved-refresh.css';

// 首页桌面端界面复刻的专用样式(最后引,可覆盖前面的级联)。
import './desktop-home.css';

import './account-improvements.css';
